import styled from 'styled-components';
import { Box } from '@lce/slice';

import SvgCentsUnderline from './assets/CentsUnderline.svg';

interface ILinecolor {
  linecolor?: string;
}

export const CentsUnderline = styled(Box)`
  align-self: flex-start;
  flex: 0 1 2.25rem;
  height: auto;
  color: inherit;
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  right: 0;
  height: 7px;
`;

export const SvgLine = styled(SvgCentsUnderline)<ILinecolor>`
  width: 100%;
  display: block;
  fill: currentColor;
  path {
    fill: ${props => props.linecolor};
  }
`;
